import { Search } from "@outschool/business-rules";
import { SearchFilters as SearchFiltersType } from "@outschool/gql-backend-generated";
import { ChildFragmentFragment } from "@outschool/gql-frontend-generated";
import { uniq } from "lodash";
import { useCallback } from "react";

function mapClassFormatAttributesToExpectedFormat(classFormats: string[]) {
  return classFormats.map(format => {
    switch (format) {
      case "live":
        return "Live online";
      case "self_paced":
        return "Self-Paced";
      default:
        return format;
    }
  });
}

export function mapClassSizeAttributesToExpectedFormat(
  classSizes: string[],
): Search.ClassSize[] {
  return uniq(
    classSizes.flatMap(size => {
      switch (size) {
        case "one_on_one":
          return ["OneOnOne"];
        case "group":
          return ["SmallGroup", "LargeGroup"];
        case "small_group":
          return ["SmallGroup"];
        case "large_group":
          return ["LargeGroup"];
        default:
          return [];
      }
    }) as Search.ClassSize[],
  );
}

function getAttributeValues(
  attributes: { key: string; value: string }[],
  key: string,
) {
  return attributes.filter(attr => attr.key === key).map(attr => attr.value);
}

export function useActiveLearnerSearchFilters(): typeof getSearchFilters {
  const getSearchFilters = useCallback(
    (activeLearner: ChildFragmentFragment | null): SearchFiltersType => {
      if (!activeLearner) {
        return {
          age: null,
          theme: null,
          format: null,
          capacityMin: null,
          capacityMax: null,
          startAfterTime: null,
          endByTime: null,
          dow: null,
        };
      }

      return {
        ...(activeLearner.age && { age: activeLearner.age.toString() }),
        ...Search.getCapacityFiltersFromClassSize(
          mapClassSizeAttributesToExpectedFormat(
            getAttributeValues(activeLearner.attributes, "class_size"),
          ),
        ),
        format: mapClassFormatAttributesToExpectedFormat(
          getAttributeValues(activeLearner.attributes, "class_format"),
        ).join(","),
      };
    },
    [],
  );

  return getSearchFilters;
}
